// extracted by mini-css-extract-plugin
module.exports = {"typeImage":"styles_typeImage__8cFgw","displayRow":"styles_displayRow__U8GWC"};